import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  primaryBadge: {
    width: 50,
    height: 25,
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.orangeLighter,
  },

  countText: { color: 'white' },
}));
